import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Typography, Button } from "@mui/material";
import styles from "./QuestionBoxInScore.module.css";
import Dropdown from "../../../assets/img/classroom/dropdown.svg";
import { useStars } from "stars-rating-react-hooks";
import DeleteIcon from '@mui/icons-material/Delete';
import swal from "sweetalert";
import { TopBar } from "../../CommonComponent/Topbar";
import { message } from "antd";

const QuestionBoxInScore = ({
  index,
  setOpen,
  question,
  context,
  AddBetterAnswer,
  ChatId,
  answer,
  botId,
  rank,
  setQuestionId,
  rerender,
  setRerender
}) => {
  /* eslint eqeqeq: 0 */
  // console.log(index);
  const [showData, setShowData] = React.useState(false);
  const [activeStyle, setActiveStyle] = React.useState(styles.outermostCard);
  const [selecting, setSelecting] = React.useState(null);
  const [rating, setRating] = React.useState(null);
  const [currentScreen, setCurrentScreen] = React.useState(
    window.location.href.split("/")[4]
  );
  const [questionNumber,setQuestionNumber] = React.useState()
  var userId = localStorage.getItem("UserId");
  React.useEffect(() => {
    console.log(window.location.href.split("/")[4]);
    if (typeof setQuestionId === 'function') {
      setQuestionId(index);
    }
  }, []);

  const config = {
    totalStars: 5,
    initialSelectedValue: rank,
    renderFull: "★",
    renderEmpty: "☆",
  };

  const {
    stars,
    getStarProps,
    getStarWrapperProps,
  } = useStars(config);

  const addBetterAnswer = (i) => {
    setQuestionId(index);
    setOpen(true);
    setQuestionNumber(i)
  };

  const [showBetterAnswer, setShowBetterAnswer] = React.useState(false);
  const [updatedAnswer, setUpdatedAnswer] = React.useState(AddBetterAnswer || "");

  const handleUpdateAnswer = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/answers/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          question,
          updatedAnswer,
        }),
      });

      if (res.ok) {
        alert("Answer updated successfully!");
        setShowBetterAnswer(false);
      } else {
        alert("Failed to update the answer.");
      }
    } catch (err) {
      console.error(err);
      alert("An error occurred while updating the answer.");
    }
  };

  const showMore = () => {
    setQuestionId(index);
    setShowData(!showData);
    if (activeStyle === styles.outermostCard) {
      setActiveStyle(styles.activeStyle);
    } else {
      setActiveStyle(styles.outermostCard);
    }
  };

  const SubmitRanks = async (e) => {
    
    e.stopPropagation();
    {
      let body = {
        UserId: localStorage.getItem("UserId"),
        BotId: botId,
        ChatId: ChatId,
        Rating: rating,
        Answer:updatedAnswer
      };
      console.log(body);
      const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/bot/getchats/?UserId=${userId}` , {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(body),
      });
      const result = await response.json();
      if (response.status == 200 || response.status == 201) {
        setSelecting(true)
        message.success("Response has been Updated!")
        
      }
    }
  };
  const deleteQuestion = async (e) => { 
    if(currentScreen == "scoreAndRating"){
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ROOT}/api/bot/getchats/?ChatId=` + index,
          {
            method: "DELETE",
            headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}
          }
        );
        console.log(response);
        if (response.status != 200 && response.status != 201 && response.status != 204) {
          
            message.success("Question has been deleted!")
            setRerender(!rerender)
      
        } else {
          message.success("Question has been deleted!")
              setRerender(!rerender)
      
        }
        const result = await response.json();
        console.log(result)
      } catch (e) {
        console.log(e);
      }
    }
    else{
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ROOT}/api/data/addQAmanually/?Id=` + index,
          {
            method: "DELETE",
            headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}
          }
        );
        console.log(response.status);
        if (response.status != 200 && response.status != 201 && response.status != 204) {
          message.error("Question could not be deleted!")
          
        } else {
          message.success("Question has been deleted!")
         
          setRerender(!rerender)
      
        }
        const result = await response.json();
        console.log(result)
      } catch (e) {
        console.log(e);
      }
    }
  }


  function DataBox() {
    return (
      
        


      <div className="flex flex-col mt-2 w-full">
      <div className="border border-black border-opacity-40 rounded-md p-4 bg-white w-full">
      <p className={`text-base ${context ? '' : 'font-semibold'} mb-2`}>
  <span className={`${context ? '' : 'font-bold'}`}>
    {context ? '' : 'Question :'}
  </span>

  {context ? (
    <pre className="whitespace-pre-wrap break-words">{question}</pre>
  ) : (
    question
  )}
</p>

        <p className="text-base font-normal whitespace-pre-wrap leading-relaxed">
          <span className="font-bold">{answer ? "Answer :":""}</span> {answer}
        </p>

        
        {currentScreen === "scoreAndRating" && ( <div className="mt-4 flex">
            <label className="block mb-1 font-bold w-[135px] text-base">
              New Response
            </label>
            <textarea
              rows="5"
              className="w-full border ml-6 px-3 py-2 text-sm focus:outline-none"
              value={updatedAnswer}
              onChange={(e) => setUpdatedAnswer(e.target.value)}
            />
           
          </div>)}
      

        {currentScreen === "scoreAndRating" && (
          <>
            <div className="mt-4 flex gap-4">
              <span {...getStarWrapperProps({ style: { cursor: "pointer" } })}>
                {stars?.map((star, i) => (
                  <span
                    key={i}
                    {...getStarProps(i, {
                      style: { fontSize: "30px", color: "gold" },
                      onClick: (event, ratedValue) => {
                        setRating(ratedValue);
                        event.stopPropagation();
                      },
                    })}
                  >
                    {star}
                  </span>
                ))}
              </span>
            </div>

            <div className="mt-4 flex gap-4">
              <button
                disabled={!rating}
                className="primary text-white px-4 py-2  transition-all"
                onClick={SubmitRanks}
              >
                RATE RESPONSE
              </button>
             
            </div>
          </>
        )}
      </div>
    </div>

      
    );
  }
  return (
    <>
   
    <div className="w-ful" >{DataBox()}</div>
    </>
  );
};

export default QuestionBoxInScore;


